(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-team-carousel').each(function () {
			let carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 12,
				slidesPerView: 1.1,
				centeredSlides: true,
				loop: false,

				breakpoints: {
					580: {
						slidesPerView: 2.1,
						centeredSlides: false,
					},
					1024: {
						slidesPerView: 3,
						centeredSlides: false,
					},
					1280: {
						slidesPerView: 4,
						centeredSlides: false,
					},
				},

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},
			});
		});
	});
})(jQuery, document, window);
